"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const unicount_1 = require("unicount");
function api(getSnapshot, submitOp) {
    return {
        // Returns the text content of the document
        get: getSnapshot,
        // Returns the number of characters in the string
        getLength() { return getSnapshot().length; },
        // Insert the specified text at the given position in the document
        insert(pos, text, callback) {
            const uniPos = unicount_1.strPosToUni(getSnapshot(), pos);
            return submitOp([uniPos, text], callback);
        },
        remove(pos, length, callback) {
            const uniPos = unicount_1.strPosToUni(getSnapshot(), pos);
            return submitOp([uniPos, { d: length }], callback);
        },
        // When you use this API, you should implement these two methods
        // in your editing context.
        //onInsert: function(pos, text) {},
        //onRemove: function(pos, removedLength) {},
        _onOp(op) {
            var pos = 0;
            var spos = 0;
            for (var i = 0; i < op.length; i++) {
                var component = op[i];
                switch (typeof component) {
                    case 'number':
                        pos += component;
                        spos += component;
                        break;
                    case 'string':
                        if (this.onInsert)
                            this.onInsert(pos, component);
                        pos += component.length;
                        break;
                    case 'object':
                        if (this.onRemove)
                            this.onRemove(pos, component.d);
                        spos += component.d;
                }
            }
        },
        onInsert: null,
        onRemove: null,
    };
}
exports.default = api;
// This triggers a bug in the typescript compiler, where it generates an
// invalid typescript declaration file.
//api.provides = {text: true}
;
api.provides = { text: true };
